import WaterHeader from "./Header";
import "./index.css";
import { useState, useEffect } from "react";
import { ShowHide } from "../components/ShowHideCompany";
import WaterFoundLocationContents from "./WaterLocationContents/WaterFoundLocation";
import WaterSymbioticInputContents from "./WaterLocationContents/WaterSymbioticInput";
import DrinkingWaterContents from "./DrinkingWater";
import FlowNumbersBox from "../components/FlowNumbersBox";
import { getWater } from "../../../../apis/Business/EnergyApi";
import EPRBox from "../components/EPRBox";
const WaterComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  const [totalObjWater, setTotalObjWater] = useState([]);
  const [totalSavedWater, setTotalSavedWater] = useState([]);
  const [systemBoundaryWater, setSystemBoundaryWater] = useState("");
  useEffect(() => {
    getWater({
      businessId: businessId,
      setTotalObj: setTotalObjWater,
      setSystemBoundaryWater: setSystemBoundaryWater,
      setTotalSavedWater: setTotalSavedWater,
    });
  }, [businessId]);

  return (
    <div className="water-container" id="water-id">
      <WaterHeader
        businessId={businessId}
        show={show}
        totalObjWater={totalObjWater}
        totalSavedWater={totalSavedWater}
      />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Water"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 2.4"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && (
        <DrinkingWaterContents
          businessId={businessId}
          systemBoundaryProps={{
            systemBoundary: systemBoundaryWater,
            setSystemBoundary: setSystemBoundaryWater,
            businessId: businessId,
            totalObjCategory: totalObjWater.category_name,
          }}
        />
      )}
      {show && <WaterFoundLocationContents businessId={businessId} />}
      {show && <WaterSymbioticInputContents businessId={businessId} />}
    </div>
  );
};

export default WaterComponent;
